import { ensureClaimCorn } from '@eigtech/shared-corn-helper'
import { UploadMeetingVideo } from '@eigtech/ui-shared-meetings'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_auth/claims/$claimNumber/_layout/meetings_/new-from-upload'
)({
  component: ClaimDetailCreateMeetingFromVideo,
})

function ClaimDetailCreateMeetingFromVideo() {
  const { claimNumber } = Route.useParams()

  return <UploadMeetingVideo entityId={ensureClaimCorn(claimNumber)} />
}
